// extracted by mini-css-extract-plugin
export var boldText = "_3h-4";
export var checkboxContainer = "_3h-6";
export var closeIcon = "_3h-i";
export var container = "_3h-0";
export var drawer = "_3h-8";
export var drawerContent = "_3h-9";
export var extraSmallText = "_3h-5";
export var fulfillmentGroupTable = "_3h-e";
export var largeText = "_3h-3";
export var loadingSpinnerContainer = "_3h-j";
export var mediumText = "_3h-2";
export var narrow = "_3h-f";
export var notificationLink = "_3h-l";
export var packageCheckIconContainer = "_3h-7";
export var slideoutHeaderActions = "_3h-g";
export var slideoutHeaderActionsShifted = "_3h-h";
export var slideoutHeaderContainer = "_3h-a";
export var slideoutModal = "_3h-c";
export var stickyHeaderWrapper = "_3h-b";
export var table = "_3h-k";
export var tableContainer = "_3h-d";
export var tertiaryText = "_3h-1";